import { FaStar, FaHandshake, FaGlobe } from "react-icons/fa";

const ourMission = {
  sub: "Our Mission",
  heading: "Creating Memorable Dining Experiences",
  content: "At our restaurant, we are dedicated to providing exceptional dining experiences and delivering outstanding service to every guest.",
  points: [
    {
      id: 1,
      icon: <FaStar />,
      title: "Culinary Excellence",
      content:
        "We aim to offer culinary excellence by crafting exquisite dishes using the finest ingredients and innovative cooking techniques.",
    },
    {
      id: 2,
      icon: <FaHandshake />,
      title: "Exceptional Service",
      content:
        "We are committed to delivering exceptional service by ensuring that every guest feels valued and well-cared for from the moment they enter our restaurant.",
    },
    {
      id: 3,
      icon: <FaGlobe />,
      title: "Global Flavors",
      content:
        "We celebrate global flavors by offering a diverse menu that features a range of international cuisines and unique culinary experiences.",
    },
  ],
};

export default ourMission;